<template>
    <div class="top_con">
         <el-button type="primary" @click="add" style="margin-top:20px;" v-if="BQAdd==true">添加</el-button>
         <el-button type="primary" @click="edit" style="margin-top:20px;"  v-if="BQEdit==true">编辑</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" highlight-current-row @current-change="handleSelectionChange"   max-height="580px">
            <el-table-column  prop="id"  label="序号"></el-table-column>
            <el-table-column  prop="labelc"  label="标签名称"></el-table-column>
            <el-table-column prop="addtime"  label="添加时间"></el-table-column>
            <el-table-column prop="upUser"  label="添加人" ></el-table-column>
            <el-table-column prop="num"  label="状态" v-if="BQqj==true">
                 <template slot-scope="scope">
                    <el-link :underline="false" @click="qy(0,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==1">启用</el-link>
                    <el-link :underline="false" @click="qy(1,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==0">禁用</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>
<script>
import {getBQList,getBQList_Add,getBQList_Edit,getBQList_qj} from '@/utils/api'
export default {
    data(){
        return{
            houseLis:[],
            formInline: {
                numbers:'',
                prodName:'',
                wid:'',
                sPrice:'',
                price:'',
                fit:'',
            },
            dialogFormVisible:false,
            chuKu:false,
            formLabelWidth: '120px',
            value:10,
            total:10,
            multipleSelection:[],
            tableData: [],
            pageNum:1,
            BQAdd:false,
            BQEdit:false,
            BQqj:false,
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                userId:this.user.uid,
            }
            getBQList(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
                this.BQAdd=res.qx.BQAdd
                this.BQEdit=res.qx.BQEdit
                this.BQqj=res.qx.BQqj
            });
        },
        
        handleSelectionChange(val){
            console.log(val)
            this.multipleSelection = val;
        },
        add(){
            this.$prompt('请输入标签名称', '添加', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(({ value }) => {
                getBQList_Add({userId:this.user.uid,labelc:value}).then(res=>{
                    let param ={
                        userId:this.user.uid,
                        numPerPage:this.value,
                        pageNum:this.pageNum,
                    } 
                    getBQList(param).then(res=>{
                        this.total=res.total;
                        this.tableData=res.list;
                        this.BQAdd=res.qx.BQAdd
                        this.BQEdit=res.qx.BQEdit
                        this.BQqj=res.qx.BQqj
                    });
                    this.$message({
                        type: 'success',
                        message: '添加成功 '
                    });
                });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        edit(){
            if(this.multipleSelection==''){
                this.$message({
                    type: 'info',
                    message: '请先选择要编辑的内容'
                });   
            }else{
                this.$prompt('请输入要修改的标签名称', '修改', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue:this.multipleSelection.labelc
                }).then(({ value }) => {
                    getBQList_Edit({id:this.multipleSelection.id,userId:this.user.uid,labelc:value}).then(res=>{
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getBQList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.BQAdd=res.qx.BQAdd
                            this.BQEdit=res.qx.BQEdit
                            this.BQqj=res.qx.BQqj
                        });
                        this.$message({
                            type: 'success',
                            message: '修改成功 '
                        });
                    })
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            }
        },
        qy(idx,id){
            this.$confirm('确定此操作, 是否继续?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let param ={
                        userId:this.user.uid,
                        id:id,
                        qy_jy:idx
                    }
                    getBQList_qj(param).then(res=>{
                        if(idx==0){
                            this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                        }else{
                            this.$message({
                                type: 'success',
                                message: '启用成功!'
                            });
                        }
                        let param ={
                            userId:this.user.uid,
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                        } 
                        getBQList(param).then(res=>{
                            this.total=res.total;
                            this.tableData=res.list;
                            this.BQAdd=res.qx.BQAdd
                            this.BQEdit=res.qx.BQEdit
                            this.BQqj=res.qx.BQqj
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        let param ={
            userId:this.user.uid,
            numPerPage:this.value,
            pageNum:this.pageNum,
        } 
        getBQList(param).then(res=>{
            this.total=res.total;
            this.tableData=res.list;
            this.BQAdd=res.qx.BQAdd
            this.BQEdit=res.qx.BQEdit
            this.BQqj=res.qx.BQqj
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/LabelManagement.vue